import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { NoSeries } from "../series/models/noSeries";
@Injectable({
    providedIn: 'root'
})
export class SeriesService{
 constructor(private httpClient:HttpClient){}    
 systemSeriesNo(){
    return this.httpClient.get<NoSeries[]>(`${environment.configUrlV2}/ModuleSequence`)
}
 editSystemSeriesNO(series:NoSeries){
        return this.httpClient.put<void>(`${environment.configUrlV2}/ModuleSequence`,series)
      }

    editSeriesCheckBox(series:NoSeries){

        return this.httpClient.put<void>(`${environment.configUrlV2}/ModuleSequence`,series)

    }  
}
